var exports = {
  "kL": "xae11d333--fa3e92--container",
  "DD": "xae11d333--fa3e92--title",
  "C5": "xae11d333--fa3e92--location",
  "qJ": "xae11d333--fa3e92--search-suggest",
};

module.exports = exports;
